import { ASSIGMENTS_ORDER_DETAIL, ASSIGMENTS_ORDER_DETAIL_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const createOrderLineAssignmentAction = (params) => async (dispatch) => {
  const { legal_id, carrier_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(`/api/companies/${legal_id}/linked-up/orders`, {
      carrier_id,
    });

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_DETAIL,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: ASSIGMENTS_ORDER_DETAIL_ERROR,
    });
  }
};
